import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "preview"]

  connect() {
    this.render()
  }

  render() {
    const text = this.sourceTarget.value || ""
    this.previewTarget.textContent = text
      ? `${text.length} tekens · live preview wordt server-side gerenderd na opslaan.`
      : "Nog geen inhoud."
  }
}
